// extracted by mini-css-extract-plugin
module.exports = {"button":"nM","disabled":"oM","wrapper":"pM"};